import { Caddy, CrewMember, RodRequestCaddy } from '@bechtel/types';

export interface AddCaddyDetailProps {
  welders: CrewMember[];
  onAddCaddy: (caddy: RodRequestCaddy) => void;
  rodRoomId: string | undefined;
  selectedCaddies: Caddy[];
}
